
import ConfigStore from './config.store'

export const stores = {
    configStore: ConfigStore
}
